import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/ProductList';

export const PRODUCT_LIST_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const PRODUCT_LIST_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
